import { Grid } from "@mui/material";
import BaseEligibilityAccordion from "app/frontend/components/eligibility/accordions/BaseEligibilityAccordion";
import { useProjectConfirmationComponents } from "app/frontend/components/eligibility/accordions/confirmation/useProjectConfirmationComponents";
import { IEligibilityProps } from "app/frontend/components/eligibility/accordions/types";
import { EEligibilityStep } from "app/frontend/components/eligibility/constants";

const ProjectConfirmationAccordion: React.FC<IEligibilityProps> = () => {
    const { h2, body } = useProjectConfirmationComponents();

    return (
        <BaseEligibilityAccordion header={""} h2={h2} step={EEligibilityStep.CONFIRMATION}>
            <Grid container spacing={0} sx={{ mt: 2 }}>
                <Grid size={{ xs: 0, md: 1, lg: 2 }}>&nbsp;</Grid>
                <Grid size={{ xs: 12, md: 10, lg: 8 }}>{body}</Grid>
                <Grid size={{ xs: 0, md: 1, lg: 2 }}>&nbsp;</Grid>
            </Grid>
        </BaseEligibilityAccordion>
    );
};

export default ProjectConfirmationAccordion;
